import { atom } from 'recoil';


export const customerRestaurantId = atom<string|null>({
  key: 'customerRestaurantId',
  default: null
});